import {
  locationIdFormat,
  productFamilyIdFormat,
  productIdFormat,
  redoCartIdFormat,
  redoCartItemIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";

const RedoCartItemSchema_ = z.object({
  id: redoCartItemIdFormat.schema,
  cartId: redoCartIdFormat.schema,
  productId: productIdFormat.schema,
  productFamilyId: productFamilyIdFormat.schema,
  title: z.string(),
  price: z.number(),
  currency: z.string(),
  imageUrl: z.string().nullable(),
  options: z.array(z.object({ name: z.string(), value: z.string() })),
  attributes: z.array(z.object({ key: z.string(), value: z.string() })),
  quantity: z.number(),
  maxQuantity: z.number().nullable(),
});
export const RedoCartItemSchema: z.ZodType<RedoCartItem> = RedoCartItemSchema_;
export interface RedoCartItem extends z.infer<typeof RedoCartItemSchema_> {}

const RedoCartSchema_ = z.object({
  id: redoCartIdFormat.schema,
  status: z.string(),
  destinationLocationId: locationIdFormat.schema.nullable(),
  items: z.array(RedoCartItemSchema),
});
export const RedoCartSchema: z.ZodType<RedoCart> = RedoCartSchema_;
export interface RedoCart extends z.infer<typeof RedoCartSchema_> {}

const RedoCartOutput = z.object({ cart: RedoCartSchema.nullable() });

export const getRedoCart = {
  name: "getRedoCart" as const,
  input: z.object({}),
  output: RedoCartOutput,
};

export const setCartDestinationLocation = {
  name: "setCartDestinationLocation" as const,
  input: z.object({ locationId: locationIdFormat.schema.nullable() }),
  output: RedoCartOutput,
};

export const upsertRedoCartItems = {
  name: "upsertRedoCartItems" as const,
  input: z.object({
    productId: productIdFormat.schema,
    productFamilyId: productFamilyIdFormat.schema,
    quantityDelta: z.number(),
    title: z.string(),
    price: z.number(),
    currency: z.string(),
    imageUrl: z.string().nullable(),
    options: z.array(z.object({ name: z.string(), value: z.string() })),
    attributes: z
      .array(z.object({ key: z.string(), value: z.string() }))
      .optional(),
  }),
  output: RedoCartOutput,
};
